(ns app.front.view.attachment.list.util
  (:require [app.front.ui :as ui]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.attachment.subs :as attachment-subs]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]))


(defn latest-version-file [attachment-version]
  (->> attachment-version
       :attachment.version/files
       (sort-by :entity/created >)
       first))


(defn latest-file [attachment]
  (->> attachment
       :attachment/versions
       (sort-by :attachment.version/version)
       last
       latest-version-file))


(defn search-matches? [hay needle]
  (when (and (string? hay) (string? needle))
    (str/includes? (str/lower-case hay) (str/lower-case needle))))


(defn search-attachments [text attachments]
  ;; TODO: What should the search target?
  (->> attachments
       (filter (fn [attachment]
                 (let [searchables [(:attachment/contents attachment)
                                    (-> attachment
                                        latest-file
                                        :attachment.version.file/filename)]]
                   (some #(search-matches? % text) searchables))))))


(defn attachment-types-column [{:keys [id]}]
  (let [contents (<sub [::attachment-subs/contents id])
        types    (<sub [::attachment-subs/attachment-types id])]
    [:<>
     (if (<sub [::ws-subs/loading-config?])
       (cc/skeleton-text)
       [:div.attachment-table__attachment-type
        (attachment-common/attachment-types-text types)])
     [:div.attachment-table__contents contents]]))


(defn visibility-column [{:keys [id tr]}]
  (when (<sub [::attachment-subs/visibility-restricted? id])
    [ui/small-pill {:kind :primary} (tr [:attachment/restricted])]))


(defn modified-column [{:keys [id]}]
  (let [{:keys [ts user]} (<sub [::attachment-subs/latest-change id])]
    [:<>
     [:div ((<sub [::date-util/date-time-fn]) ts)]
     [:div user]]))
